import React from "react";

const Glogo = ({ hasStroke, size, color = "#ffffff" }) => {
  return (
    <svg
      className="no-print"
      version="1.1"
      x="0px"
      y="0px"
      width={
        size === "md"
          ? "60px"
          : size === "sm"
          ? "30px"
          : size === "lg"
          ? "100px"
          : "auto"
      }
      height={
        size === "md"
          ? "31px"
          : size === "sm"
          ? "18px"
          : size === "lg"
          ? "52px"
          : "auto"
      }
      viewBox={size === "md" ? "-70 0 300 150" : "0 0 188.5 130"}
      fill={color}
      stroke="black"
      strokeWidth={hasStroke ? 3 : 0}
    >
      <path
        d="M93,40.8c10.9-5.6,20.5-10.2,28.6-13.9C100.3,2.1,62.9-0.8,38.1,20.5C17.9,37.9,11.7,66.7,23.2,90.8
c7.9-6.3,16.2-12.2,24.8-17.7c0.1,0,0.1-0.1,0.2-0.1c-0.7-2.5-1-5-1-7.6c0-16.4,13.2-29.6,29.6-29.6C82.5,35.8,88.2,37.5,93,40.8"
      />
      <path
        d="M186.2,5.1c-3.5-1.1-7.1-2-10.8-2.6c-8.1-1.4-19.4-2.2-29.1,1.3c-8.9,3.3-14.4,11.3-12.8,18.6
c13.7-4.6,22.7-6.1,22.5-6c-3.7,1.3-46.5,17.2-108.2,56.8c-64.6,41.5-55.4,62.7-14.4,47.1c4.3-1.6,8.1-3.1,11.7-4.6
c27.7,17.4,64.3,9,81.6-18.8c5.9-9.4,9-20.3,9-31.5c0-5-0.6-10-1.9-14.8h-29.4c-15,9.3-30.2,19.3-44,29.6h41.8
c-8,14.2-26.1,19.3-40.4,11.2c-3-1.7-5.6-3.9-7.9-6.4c-6.1,4.7-11.8,9.5-17.2,14.3c-1.9,1.7-3.6,3.3-5.2,4.8
c2.9,3.3,6.1,6.3,9.6,8.9c-11.7,2.7-35.7,6.1-5.9-20.7c30.7-27.6,82.7-54.2,101.7-63.5c4.3,4.3,11.7,5.4,19.2,2.7
c9.7-3.5,17.1-13.2,22.3-19.5C181,9.5,183.5,7.1,186.2,5.1"
      />
      {/*
      <path
        d="M498-89.3h-9.4l-6.1,12l-6.2-12h-9.6l11.3,20.2l-8,14.9h9.3L498-89.3z M456.3-78.6l9.7-10.7h-10.7l-4.2,4.8
l-4.2-4.8h-10.5l9.5,10.7l-11.7,12.7H445l6-6.9l6,6.9h10.9L456.3-78.6z M423.7-65.9h8.3v-23.4h-8.3v2.3c-1.9-2-4.5-3.1-7.3-3
c-6.9,0-11.7,5.7-11.7,12.4s4.9,12.5,11.8,12.5c2.7,0,5.6-1,7.1-3.4h0.1V-65.9z M424-77.6c0,2.9-2.4,5.3-5.3,5.3
c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3C421.6-83,424-80.6,424-77.6 M392.6-65.9h8.3v-37.9h-8.3V-65.9z M378.8-65.9h8.3
v-23.4h-8.3v2.3c-1.9-2-4.5-3.1-7.3-3c-6.9,0-11.7,5.7-11.7,12.4s4.9,12.5,11.8,12.5c2.7,0,5.6-1,7.1-3.4h0.1V-65.9z M379.1-77.6
c-0.1,2.9-2.6,5.2-5.6,5.1c-2.8-0.1-5-2.3-5.1-5.1c0.1-2.9,2.6-5.2,5.6-5.1C376.8-82.6,379-80.4,379.1-77.6 M339.9-78.1h7.3
c-0.4,4-3.3,6-7.2,6c-5.9,0-9.1-5.4-9.1-10.8s3-10.9,8.9-10.9c3.6,0,6.2,2.2,7.4,5.5l8.5-3.6c-3-6.4-8.4-9.6-15.5-9.6
c-11.1,0-18.7,7.3-18.7,18.5c0,10.8,7.5,18.2,18.3,18.2c5.7,0,10.8-2.1,14.2-6.8c3.1-4.3,3.4-8.6,3.5-13.6h-17.7V-78.1z M293.7-65.9
h8.3v-14.5c0-5.8-2.5-9.7-8.8-9.7c-3.2,0-5.6,1-7.5,3.8h-0.1v-3h-8.3v23.4h8.3v-12.1c0-2.9,1-5.4,4.3-5.4c4.1,0,3.7,3.9,3.7,6.2
L293.7-65.9z M256.1-76.2h17.5v-0.9c0-8-4.7-13-12.8-13c-7.6,0-13,4.7-13,12.5c0,8.1,5.8,12.5,13.5,12.5c5.3,0,10.6-2.5,11.9-8h-8
c-0.8,1.4-2.4,2.3-4,2.1C257.8-71,256-72.8,256.1-76.2 M256.1-81c0.8-2.7,3.5-4.2,6.2-3.4c1.7,0.5,3,1.8,3.4,3.4H256.1z M228.1-76.2
h17.5v-0.9c0-8-4.7-13-12.8-13c-7.6,0-13,4.7-13,12.5c0,8.1,5.8,12.5,13.5,12.5c5.3,0,10.6-2.5,11.9-8h-8c-0.8,1.4-2.4,2.3-4,2.1
c-3.4,0-5.2-1.8-5.2-5.2 M228.2-81c0.5-2.7,3.1-4.5,5.8-4c2.1,0.4,3.7,2,4,4H228.2z M214.8-82.4c1.2-0.1,2.4,0.2,3.5,0.8v-8H217
c-3.1-0.2-6,1.4-7.6,4.2h-0.1v-3.9H201v23.4h8.3v-9.4c0-4,1.1-7.1,5.8-7.1 M179.3-78.1h7.3c-0.4,4-3.3,6-7.2,6
c-5.9,0-9.1-5.4-9.1-10.8s3-10.9,8.9-10.9c3.6,0,6.2,2.2,7.4,5.5l8.5-3.6c-3-6.4-8.4-9.6-15.5-9.6c-11.1,0-18.6,7.3-18.6,18.5
c0,10.8,7.5,18.2,18.3,18.2c5.8,0,10.8-2.1,14.2-6.8c3-4.3,3.4-8.6,3.5-13.6h-17.7L179.3-78.1z M93-99.2
c10.9-5.6,20.5-10.2,28.6-13.9c-21.3-24.8-58.7-27.7-83.5-6.4c-20.3,17.4-26.4,46.2-14.9,70.3c7.9-6.3,16.2-12.2,24.8-17.7
c0.1,0,0.1-0.1,0.2-0.1c-0.7-2.5-1-5-1-7.6c0-16.4,13.2-29.6,29.6-29.6C82.5-104.2,88.2-102.5,93-99.2"
      />
      <path
        d="M186.2-134.9c-3.5-1.1-7.1-2-10.8-2.6c-8.1-1.4-19.4-2.2-29.1,1.3c-8.9,3.3-14.4,11.3-12.8,18.6
c13.7-4.7,22.7-6.1,22.5-6c-3.7,1.3-46.5,17.2-108.2,56.8C-16.7-25.4-7.5-4.2,33.6-19.7c4.3-1.6,8.1-3.1,11.7-4.6
c27.7,17.4,64.3,9,81.6-18.8c5.9-9.4,9-20.3,9-31.5c0-5-0.6-10-1.9-14.8h-29.4c-15,9.3-30.2,19.3-44,29.6h41.8
c-8,14.2-26.1,19.3-40.4,11.2c-3-1.7-5.6-3.9-7.9-6.4c-6.1,4.7-11.8,9.5-17.2,14.3c-1.9,1.7-3.6,3.3-5.2,4.8
c2.9,3.3,6.1,6.3,9.6,8.9c-11.7,2.7-35.7,6.1-5.9-20.7c30.7-27.6,82.7-54.2,101.7-63.5c4.3,4.3,11.7,5.4,19.2,2.7
c9.7-3.5,17.1-13.2,22.3-19.5C181-130.5,183.5-132.9,186.2-134.9"
      />
      <path d="M412.9-51.4v8.2c0.4,0,0.8,0.1,1.2,0.1c2.5,0,4.3-1.6,4.3-4C418.4-51,415.3-51.4,412.9-51.4z" />
      <path
        d="M208.5-50.4c-0.6-1.9-1-3.1-1.2-3.8h-3.8c-0.2,0.8-0.6,1.8-1.1,3.1l-5.9,15.6c-0.5,1.5-1.2,2.9-2.1,4.2h5.3
c-0.2-0.3-0.2-0.7-0.2-1.1c0.1-1.2,0.4-2.4,0.9-3.5l4.3-12.2h0.1l4.5,13c0.3,0.8,0.6,1.6,0.6,2.4c0,0.5-0.1,0.9-0.4,1.3h5.9
c-0.7-1.2-1.3-2.5-1.8-3.9L208.5-50.4z"
      />
      <path
        d="M220.5-42.9c0-5.4,3.1-8.7,8.3-8.7c3.8,0,5.3,1.2,6.1,1.9l0.2-4.3c-0.1,0-0.3,0-0.5,0c-1.8-0.3-3.7-0.5-5.5-0.6
c-7.9,0-13.3,5.1-13.3,12.2c0,6.1,4.8,11.4,12,11.5h0.1c4.1,0,6.7-1.4,8-1.5v-4.2c-1.9,1.9-4.6,2.9-7.3,2.8
C223.6-33.9,220.5-37.4,220.5-42.9z"
      />
      <path
        d="M258.3-54.2h-5.9c0.5,1,0.8,1.4,0.8,4.2v5.6h-9.9V-50c0-2.7,0.3-3.2,0.8-4.2h-5.9c0.5,1,0.8,1.4,0.8,4.2v14.5
c0,2.7-0.3,3.2-0.8,4.2h5.9c-0.5-1-0.8-1.4-0.8-4.2v-5.7h9.9v5.7c0,2.7-0.3,3.2-0.8,4.2h5.9c-0.5-1-0.8-1.4-0.8-4.2V-50
C257.5-52.8,257.8-53.2,258.3-54.2z"
      />
      <path
        d="M267.7-54.2h-5.9c0.5,1,0.8,1.4,0.8,4.2v14.5c0,2.7-0.3,3.2-0.8,4.2h5.9c-0.5-1-0.8-1.4-0.8-4.2V-50
C266.9-52.8,267.2-53.2,267.7-54.2z"
      />
      <path
        d="M269.8-50.3c2.3-0.6,4.6-0.9,6.9-0.9v14c0,3.4-0.1,4-1.1,5.8h6.4c-0.9-1.7-1.1-2.5-1.1-5.8v-14c2,0,4,0.3,6,0.8
l1.3-3.8h-17L269.8-50.3z"
      />
      <path
        d="M295.1-34.5v-7c0.7-0.1,1.5-0.1,2.2-0.1c1.3,0,2.7,0.2,4,0.6l1.2-3.5h-7.3v-6.6c0.5-0.1,1-0.1,1.6-0.1
c3.2,0,3.6,0.1,5.5,0.8l1.2-3.7H290c0.5,1,0.8,1.4,0.8,4.2v14.5c0,2.7-0.3,3.2-0.8,4.2h12.4l1.2-3.9c-2.2,0.7-4.5,1-6.9,0.9
C296.3-34.4,295.6-34.4,295.1-34.5z"
      />
      <path
        d="M317.4-43.8l4.6-6.6c0.9-1.4,2-2.7,3.2-3.8h-5.6v0.6c-0.2,1.1-0.6,2.1-1.3,2.9l-2.7,4l-2.8-4.3
c-0.5-0.6-0.8-1.4-0.9-2.2c0-0.4,0.1-0.7,0.2-1.1h-6.7c0.9,1.2,1.8,2.4,2.6,3.7l4.8,7.6l-4.8,7.1c-1,1.6-2.2,3.1-3.5,4.4h5.9
c-0.2-0.3-0.3-0.6-0.3-1c0.3-1,0.8-2,1.5-2.8l3.3-4.8l3.1,5c0.5,0.8,1.3,1.7,1.3,2.7c0,0.3-0.1,0.6-0.3,0.8h6.7
c-1-1.2-1.9-2.4-2.7-3.7L317.4-43.8z"
      />
      <path
        d="M364.8-54.2h-5.9c0.5,1,0.8,1.4,0.8,4.2v14.5c0,2.7-0.3,3.2-0.8,4.2h5.9c-0.5-1-0.8-1.4-0.8-4.2V-50
C364-52.8,364.2-53.2,364.8-54.2z"
      />
      <path
        d="M384.2-48.7v10.1h-0.1l-9.5-12.7c-1.3-1.7-1.5-2.2-1.6-3H367c0.8,1,1.6,2,2.2,3.1v14.6c0.1,1.7-0.2,3.4-0.9,5
h5.2c-0.4-0.9-0.9-2-0.9-5v-10.4h0.1l11,15.5h3.9v-17.2c0-3,0.2-4.3,0.8-5.6h-5C384.1-52.5,384.2-52,384.2-48.7z"
      />
      <path
        d="M396.9-34.5v-7c0.7,0,1.5-0.1,2.2-0.1c1.3,0,2.7,0.2,4,0.6l1.2-3.5h-7.3v-6.6c0.5-0.1,1-0.1,1.6-0.1
c1.9-0.2,3.8,0.1,5.5,0.8l1.2-3.7h-13.3c0.5,1,0.8,1.4,0.8,4.2v14.5c0,2.7-0.3,3.2-0.8,4.2h12.4l1.2-3.9c-2.2,0.7-4.5,1-6.9,0.9
C398.1-34.4,397.4-34.4,396.9-34.5z"
      />
      <path
        d="M418.4-41.6c1.8-0.7,4.8-1.8,4.8-5.9c-0.1-1.9-1-3.8-2.5-5c-1.2-1-3-1.8-7-1.8c-2,0-2.7,0.1-5.9,0.1
c0.6,1,0.9,2.2,0.9,3.3v14.3c0,3.1-0.1,3.3-0.8,5.1h5.7c-0.6-1.4-0.7-2.2-0.7-5.2v-5.4h0.2l7.2,10.7h6.1c-1.5-1.5-2.9-3.1-4.2-4.9
L418.4-41.6z M414.1-43.1c-0.4,0-0.8-0.1-1.2-0.1v-8.2c2.4,0,5.5,0.4,5.5,4.2C418.4-44.7,416.5-43.1,414.1-43.1L414.1-43.1z"
      />
      <path
        d="M444.7-54.2h-5.3c0.2,0.3,0.3,0.7,0.2,1.1c-0.1,1.2-0.4,2.4-0.9,3.5l-4.3,12.2h-0.1l-4.5-13
c-0.4-0.7-0.6-1.5-0.6-2.4c0-0.5,0.1-0.9,0.4-1.4h-5.9c0.7,1.2,1.3,2.5,1.8,3.9l5.3,15.1c0.6,1.9,1,3,1.2,3.8h3.8
c0.3-0.8,0.6-1.8,1.1-3.1l5.9-15.5C443.1-51.5,443.8-52.9,444.7-54.2z"
      />
      <path
        d="M461.7-31.3c-0.7-1.2-1.3-2.5-1.8-3.9l-5.3-15.1c-0.6-1.9-1-3.1-1.2-3.8h-3.8c-0.3,0.8-0.6,1.8-1.1,3l-5.9,15.6
c-0.5,1.5-1.2,2.9-2.1,4.2h5.3c-0.2-0.3-0.3-0.7-0.2-1.1c0.1-1.2,0.4-2.4,0.9-3.5l4.3-12.2h0.1l4.5,13c0.4,0.7,0.6,1.6,0.6,2.4
c0,0.5-0.1,0.9-0.4,1.4H461.7z"
      />
      <path
        d="M353.9-50c-0.1-2.7,0.3-3.2,0.9-4.1h-5.5c-0.3,0.7-0.6,1.4-0.9,2.1l-6.1,12.6l-6.9-14.7h-5.5
c0.6,0.7,1.2,1.5,1.7,2.3L330-36.7c-0.2,2.4-0.3,3.2-1.3,5.1h4.9c-0.4-0.7-0.5-1.4-0.5-2.2c0-0.8,0-1.6,0.1-2.3l1-10.9h0.1l7.2,15.4
l8.3-16.9h0.2l0.2,11.6c0.1,2.9,0,4-0.9,5.3h6c-0.8-1.5-1-2.5-1.1-5.3L353.9-50z"
  />*/}
    </svg>
  );
};

export default Glogo;
